__turbopack_context__.v({
  "active": "UgioMW_active",
  "button": "UgioMW_button",
  "icon": "UgioMW_icon",
});
